import { render } from "./createdMe.vue?vue&type=template&id=3a34b685"
import script from "./createdMe.vue?vue&type=script&lang=js"
export * from "./createdMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__